import { CHATTER_CONSULTATION_REPORT_V2_QUESTIONS, CONSULTATION_REPORT_V2_QUESTIONS, INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS } from "config/constants";
import { getQuestionById, isHTMLContentEmpty } from "helpers/common";
import { numberRequiredSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, date, object, string } from "yup";

const getValidationSchema = (currentTab, reportQuestions) => {
    switch (currentTab) {
        case 1:
            return object().shape({
                screening_date: date()
                    .nullable()
                    .required('Screening date is required'),
            });
        case 2:
            //   const locationQuestion = getQuestionById(INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.location, reportQuestions);
            //   const inputLabels = locationQuestion?.question_dd_labels || [];
            //   const labelsValidation = {};
            //   inputLabels?.length && inputLabels.forEach(label => {
            //     labelsValidation[label] = stringRequiredSchema;
            //   })

            return object({
                [CHATTER_CONSULTATION_REPORT_V2_QUESTIONS.program_description]: object({
                    answer: string().required('This field is required'),
                }),
                groupLeaderList: array().of(
                    object().shape({})
                ).min(1, "Please select at least one group leader."),
            });
        case 3:
            return object().shape({
                observations: array().of(
                    object().shape({
                        notes: stringRequiredSchema,
                        strategy: array().of(
                            object().shape({
                                answers: string()
                                    .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                                    .required('This field is required'),
                                // tracker_percentage: numberRequiredSchema
                            })
                        ).min(1, "Atleast 1 strategy is required."),
                    })
                ).min(1, "Atleast 1 goal is required."),
            });

        case 4:
            return object().shape({
                [CHATTER_CONSULTATION_REPORT_V2_QUESTIONS.clinical_summary]: object({
                    answer: string().required('This field is required'),
                }),
                recommendation: array().of(
                    object().shape({
                        answers: string()
                            .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                            .required('This field is required'),
                    })
                ),
            });
    }
}

export default getValidationSchema;